
var Intesa = Intesa || {};


Intesa.Bid = function() {
	var bid = this;
	var origTables;
	var tables = $("div[data-type-table]");
	var inputForArchive = $("#bid-json");
	
	this.init = function() {	
		origTables = tables.clone();
		$(tables).each(function(index){
			var table = $(this);
			var tableType = table.attr("data-type-table");
			if(tableType == "tableSurface"){
				bid.createTable(tableType, '');
			}
		});
	};


	this.createTable = function(tableType, datePickerId){
		
		console.log($("div[data-type-table]").length);
		
		var table = $("div[data-type-table="+tableType+"]");
		
		var indexForEcbArchive = 0;
			var json = $("#bid-json").val();
	
			
			if(json != ""){
				var obj = JSON.parse(json);
				//rimozione hrk per pbz euro project
				if(obj.bids.HRK != null){
					delete obj.bids.HRK;
				}
				if(datePickerId != ''){
					$(".-js-date-exchange-valid-"+tableType).text($("#"+datePickerId).val());
					var d = new Date();
				    var yesterday = new Date($("#"+datePickerId).val().split('.')[2], $("#"+datePickerId).val().split('.')[1]-1, $("#"+datePickerId).val().split('.')[0]) ;
				    yesterday.setDate(yesterday.getDate() - 1);
				    var yesterdayMonth = '' + (yesterday.getMonth() + 1);
				    var yesterdayDay = '' + yesterday.getDate();
				    var yesterdayYear = yesterday.getFullYear();
					$(".-js-date-exchange-established").text([yesterdayDay, yesterdayMonth, yesterdayYear].join('.'));

				    
				} else {
				    var d = new Date();
			        var month = '' + (d.getMonth() + 1);
			        var day = '' + d.getDate();
			        var year = d.getFullYear();
				    
				    var yesterday = new Date();
				    yesterday.setDate(d.getDate() - 1);
				    var yesterdayMonth = '' + (yesterday.getMonth() + 1);
				    var yesterdayDay = '' + yesterday.getDate();
				    var yesterdayYear = yesterday.getFullYear();
			
				    if (month.length < 2) 
				        month = '0' + month;
				    if (day.length < 2) 
				        day = '0' + day;
				    if (yesterdayMonth.length < 2) 
				    	yesterdayMonth = '0' + yesterdayMonth;
				    if (yesterdayDay.length < 2) 
				    	yesterdayDay = '0' + yesterdayDay;
				
				    
					$(".-js-date-exchange-valid-"+tableType).text([day, month, year].join('.'));
					$(".-js-date-exchange-established").text([yesterdayDay, yesterdayMonth, yesterdayYear].join('.'));
				}
				var clonedTable = table.clone();
				var columnsList = table.find("ul.tbl2__highlist");
				var columnsRow = columnsList.find("li.tbl2__highlistItem");
				var columnsRowList = columnsRow.find("ul.tbl__highlist"); // contenitore per le colonne dentro la riga
				var columns = columnsRowList.find("li.tbl__highlistItem"); // singola colonna 
				var head = table.find(".tbl2__head__highlist");
				var totalColumns = head.find(".tbl__highlistItem").length;
				var columnsHead = head.find("ul.tbl__highlist");
				var columnsItem = columnsHead.find("li.tbl__highlistItem");
			    console.log(totalColumns);
			    columnsRowList.html("");
			    columnsList.html("");
			    columnsHead.html("");
			    // in questo ciclo creo l'head della tabella
			    for(counter = 0; counter < Object.keys(obj.bids).length; counter++){
		   	     	var clonedHead = columnsItem.clone();
		   	     	clonedHead = '<li class="tbl__highlistItem"><span class="tbl__highlistValue"><strong>'+Object.keys(obj.bids)[counter]+'</strong></span></li>';
		   		    columnsHead.append(clonedHead);
			    }
			    var d = 0;
				//riempio la risposta del servizio con i valori mancanti inserendo come percentuale un valore vuoto
				var obj = JSON.parse($("#bid-json").val());
				var cmdObj = obj.bids;
				for (var i = 0 ; i < Object.keys(cmdObj).length; i++){
					if( cmdObj[Object.keys(cmdObj)[i]].length != 6){
                        for (var k = 0 ; k < cmdObj[Object.keys(cmdObj)[i]].length ; k++){
							var checkUnit = [{"interestCode":"PBZON","interestName":"bid O/N","revalPeriod":1,"revalUnit":"DAY","currency":"EUR","percentage":"","currencyClause":"no"},{"interestCode":"PBZ1T","interestName":"bid 1 tjedan","revalPeriod":1,"revalUnit":"WEEK","currency":"EUR","percentage":"","currencyClause":"no"},{"interestCode":"PBZ1M","interestName":"bid 1 mjesec","revalPeriod":1,"revalUnit":"MONTH","currency":"EUR","percentage":"","currencyClause":"no"},{"interestCode":"PBZ3M","interestName":"bid 3 mjeseca","revalPeriod":3,"revalUnit":"MONTH","currency":"EUR","percentage":"","currencyClause":"no"},{"interestCode":"PBZ6M","interestName":"bid 6 mjeseci","revalPeriod":6,"revalUnit":"MONTH","currency":"EUR","percentage":"","currencyClause":"no"},{"interestCode":"PBZ1G","interestName":"bid 1 godina","revalPeriod":12,"revalUnit":"MONTH","currency":"EUR","percentage":"","currencyClause":"no"}];
							var check = cmdObj[Object.keys(cmdObj)[i]][k].interestCode.split(cmdObj[Object.keys(cmdObj)[i]][k].currency.toUpperCase())[1];
							if(check != checkUnit[k].interestCode){							
								console.log("different ->"+check);
								cmdCheckUnit = checkUnit[k];
								cmdCheckUnit.currency = cmdObj[Object.keys(cmdObj)[i]][k].currency;
								cmdCheckUnit.interestCode = cmdObj[Object.keys(cmdObj)[i]][k].currency + check;
								cmdObj[Object.keys(cmdObj)[i]].splice(k,0,cmdCheckUnit);
							}else{
								console.log("same ->",check);
							}
							if(cmdObj[Object.keys(cmdObj)[i]].length == 6){
								break;
							}
						}
					}
				}
				obj.bids = cmdObj;
			    //itero come primo ciclo sulle key che corrispondono alle currency
			    for(counter = 0; counter < Object.keys(obj.bids).length;){
			    	//utilizzo le key per iterare sugli array di valori presenti al loro interno
		   	     	$.each(obj.bids[Object.keys(obj.bids)[counter]], function(firstKey, firstValue) {
			   	     	var clonedRow = columnsRow.clone();
			   	        var columnsRowListCloned = columnsRowList.clone();
			   	        var valueResult ="";
			   	        var labelForDuration = "";
				    	$.each(obj.bids, function(key, value) {		
				    		//qui itero per creare le righe, ogni iterata crea un record per ogni key (che corrispondono all'head della tabella) currency 1 record 1 e via
			   		    	var cloned = columns.clone();
							if (value[d].percentage != ""){
								valueResult = value[d].percentage + " %";
							}else{
								valueResult = "";
							}
				   		    cloned.html('<span class="tbl__highlistLabel"></span><span class="tbl__highlistValue"><strong>'+valueResult+'</strong></span>');
				   		    columnsRowListCloned.append(cloned);
				   		    labelForDuration = value[d].interestName.split("bid")[1].trim();

						    if($(document).find('html').attr('lang') == 'en'){
								
							labelForDuration = labelForDuration.replace('tjedan', 'week').replace('tjedni', 'weeks').replace('mjeseci', 'months').replace('mjeseca', 'months').replace('mjesec', 'month').replace('dana', 'days').replace('dan', 'day').replace('godina', 'year').replace('godine', 'years');
						    }

				   		});
				    	clonedRow.find("div.tbl__textWrapper div.tbl__label").text(labelForDuration);
		   		    	clonedRow.find("div.tbl__textWrapper").append(columnsRowListCloned);
		   		    	
			   		    columnsList.append(clonedRow);
			   		    //dopo ogni riga incremento il contatore dell'array interno alle key interno così prendo il valore successivo
				    	d++;
				    	// incremento anche il primo contatore così da poter uscire da tutti i cicli
                        counter++;
					});
			    }
			}
	
	};
	
	
	
	
	
	
	this.formatNumber = function (value){
		return Number(value).toFixed(6);
	};
	
											
	this.clearTable = function(tableType){
		
		$(origTables).each(function(index){
			if($(this).attr("data-type-table") == tableType){
				$("div[data-type-table="+tableType+"]").html('');
				$("div[data-type-table="+tableType+"]").html($(this).html());
			}
		});
	};
	
	this.search = function (element, datePickerId, tableType) {
		var datePicker = $("#"+datePickerId);
		var d = new Date();
		var startingDate = bid.formatDate(bid.formatSlashedDate(datePicker.val().slice(0,10).split(".").join("/")));
		var endpoint = window.location.origin + $("#bid-url").val() + "&date="+startingDate+"";
		bid.clearTable(tableType);
		bid.getJsonAjaxControl(endpoint, inputForArchive, tableType, datePickerId, startingDate, 0);
	};
	  
	this.getJsonAjax = function (endpoint, element, tableType, datePickerId){
		console.log("invoked url: " + endpoint);	
		$.ajax({
			  method: "GET",
			  url: endpoint
			})
			.done(function( data ) {
				if(data != null){
					console.log("----" + JSON.stringify(data) +"----");
				  	$(element).val(JSON.stringify(data));
				  	bid.createTable(tableType, datePickerId);
				}
			});
	};
	
	
	this.getJsonAjaxControl = function (endpoint, element, tableType, datePickerId, startingDate, counter){
		console.log("invoked url: " + endpoint);	
		$.ajax({
			  method: "GET",
			  url: endpoint
			})
			.done(function( data ) {
				if(data != null && JSON.parse(JSON.stringify(data)).statusCode == 200){
					console.log("----" + JSON.stringify(data) +"----");
					var datePicker = $("#"+datePickerId);
					var d = new Date();
					var startDate = startingDate;
					//formatDate(formatSlashedDate(datePicker.val().slice(0,10).split(".").join("/")))
					var endpoint = window.location.origin + $("#bid-url").val() + "&date="+startingDate+"";
					bid.clearTable(tableType);
					bid.getJsonAjax(endpoint, inputForArchive, tableType, datePickerId);
				}
			});
	};
	
	this.formatDate = function (date) {
	    var d = new Date(date),
	        month = '' + (d.getMonth() + 1),
	        day = '' + d.getDate(),
	        year = d.getFullYear();
	
	    if (month.length < 2) 
	        month = '0' + month;
	    if (day.length < 2) 
	        day = '0' + day;
	
	    return [year, month, day].join('-');
	};
	
	this.formatSlashedDate = function (date){
		var dateString = date; // Oct 23
	
		var dateParts = dateString.split("/");
	
		// month is 0-based, that's why we need dataParts[1] - 1
		var dateObject = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0]); 
		
		return dateObject.toDateString();
	};
	
	
};

/**
 * Get class instance
 *
 */
Intesa.Bid.getInstance = function() {
	
	if( !window.intesa ) {
		
		window.intesa = new Object();
		
	}
	if( !window.intesa.bid ) {
		
		window.intesa.bid = new Intesa.Bid();
		
	}
	
	return window.intesa.bid;

};
